import { fmtDate } from "@/lib/formatDate";
import { createContext, useContext, useMemo, useState } from "react";

const DateRangeContext = createContext(null);

const today = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};
const addDays = (date, n) => {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
};

export const PRESETS = [
  { key: "today", label: "Oggi", days: 1 },
  { key: "7d", label: "Ultimi 7 giorni", days: 7 },
  { key: "30d", label: "Ultimi 30 giorni", days: 30 },
  { key: "90d", label: "Ultimi 90 giorni", days: 90 },
];

const presetRange = (days) => ({ from: addDays(today(), -(days - 1)), to: today() });

export function DateRangeProvider({ children }) {
  const [range, setRange] = useState(() => presetRange(30));

  const days = useMemo(() => {
    if (!range?.from || !range?.to) return 30;
    const diff = Math.round((range.to - range.from) / 86400000) + 1;
    return Math.max(1, diff);
  }, [range]);

  const label = useMemo(() => {
    const preset = PRESETS.find((p) => p.days === days);
    if (preset) return preset.label;
    const fmt = (d) => fmtDate(d);
    return `${fmt(range.from)} – ${fmt(range.to)}`;
  }, [days, range]);

  const setPreset = (p) => setRange(presetRange(p.days));
  const setCustom = (r) => r?.from && setRange({ from: r.from, to: r.to || r.from });

  return (
    <DateRangeContext.Provider value={{ range, days, label, setPreset, setCustom }}>
      {children}
    </DateRangeContext.Provider>
  );
}

export const useDateRange = () => useContext(DateRangeContext);
